import { useEffect } from 'react';

export default function useComponentDidMount(onMount = null, onDismount = null) {
  useEffect(() => {
    if (onMount) onMount();
    return () => {
      if (onDismount) onDismount();
    };
  }, []);
}
